import { wstETH } from '~/constants/tokens'
import { useTokenBalance } from '~/state/wallet/hooks'

export const useWstEthBalance = () => {
  const wstETHBalance = useTokenBalance(wstETH)

  return wstETHBalance
}
